/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddContractDocumentVersionDto,
  AttachClauseDto,
  ChangeContractStatusDto,
  ClauseLibraryControllerListV1200,
  ClauseLibraryControllerListV1Params,
  ContractDocumentsControllerDownloadV1Params,
  ContractDto,
  ContractSummaryDto,
  ContractsControllerListV1200,
  ContractsControllerListV1Params,
  ContractsControllerRenewalsV1200,
  ContractsControllerRenewalsV1Params,
  ContractsControllerVersionsV1200,
  ContractsControllerVersionsV1Params,
  CreateContractDocumentDto,
  CreateContractDto,
  CreateSignatureRequestDto,
  DocumentDownloadDto,
  IncentiveInputDto,
  LibraryClauseDto,
  RemoveContractResponseDto,
  RemoveResponseDto,
  SystemClausesResponseDto,
  UpdateContractDto,
  UpdateIncentiveDto,
  UpsertLibraryClauseDto,
  VoidSignatureRequestDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getContractsControllerListV1Url = (params?: ContractsControllerListV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/contracts?${stringifiedParams}` : `/v1/contracts`
}

/**
 * Paginated. `quick` is the chip row; `status`, `type`, `playerId` and `counterpartyClubId` narrow further. Search covers title, counterparty and player name, and an exact reference such as `OG-12`.
 * @summary The register
 */
export const contractsControllerListV1 = async (params?: ContractsControllerListV1Params, options?: RequestInit): Promise<ContractsControllerListV1200> => {

  return apiRequest<ContractsControllerListV1200>(getContractsControllerListV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getContractsControllerListV1QueryKey = (params?: ContractsControllerListV1Params,) => {
    return [
    `/v1/contracts`, ...(params ? [params] : [])
    ] as const;
    }


export const getContractsControllerListV1QueryOptions = <TData = Awaited<ReturnType<typeof contractsControllerListV1>>, TError = unknown>(params?: ContractsControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerListV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsControllerListV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsControllerListV1>>> = ({ signal }) => contractsControllerListV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsControllerListV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsControllerListV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractsControllerListV1>>>
export type ContractsControllerListV1QueryError = unknown


export function useContractsControllerListV1<TData = Awaited<ReturnType<typeof contractsControllerListV1>>, TError = unknown>(
 params: undefined |  ContractsControllerListV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerListV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerListV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerListV1<TData = Awaited<ReturnType<typeof contractsControllerListV1>>, TError = unknown>(
 params?: ContractsControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerListV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerListV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerListV1<TData = Awaited<ReturnType<typeof contractsControllerListV1>>, TError = unknown>(
 params?: ContractsControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerListV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The register
 */

export function useContractsControllerListV1<TData = Awaited<ReturnType<typeof contractsControllerListV1>>, TError = unknown>(
 params?: ContractsControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerListV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsControllerListV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractsControllerCreateV1Url = () => {




  return `/v1/contracts`
}

/**
 * Created as a draft with the next `OG-<n>` reference and a v1 history entry. Either a counterparty club or a counterparty name, never both; neither is allowed until the contract is executed.
 * @summary Start a contract
 */
export const contractsControllerCreateV1 = async (createContractDto: CreateContractDto, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractsControllerCreateV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createContractDto)
  }
);}





export const getContractsControllerCreateV1QueryKey = (createContractDto?: CreateContractDto,) => {
    return [
    'POST', `/v1/contracts`, createContractDto
    ] as const;
    }


export const getContractsControllerCreateV1QueryOptions = <TData = Awaited<ReturnType<typeof contractsControllerCreateV1>>, TError = void>(createContractDto: CreateContractDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerCreateV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsControllerCreateV1QueryKey(createContractDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsControllerCreateV1>>> = ({ signal }) => contractsControllerCreateV1(createContractDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsControllerCreateV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsControllerCreateV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractsControllerCreateV1>>>
export type ContractsControllerCreateV1QueryError = void


export function useContractsControllerCreateV1<TData = Awaited<ReturnType<typeof contractsControllerCreateV1>>, TError = void>(
 createContractDto: CreateContractDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerCreateV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerCreateV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerCreateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerCreateV1<TData = Awaited<ReturnType<typeof contractsControllerCreateV1>>, TError = void>(
 createContractDto: CreateContractDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerCreateV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerCreateV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerCreateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerCreateV1<TData = Awaited<ReturnType<typeof contractsControllerCreateV1>>, TError = void>(
 createContractDto: CreateContractDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerCreateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Start a contract
 */

export function useContractsControllerCreateV1<TData = Awaited<ReturnType<typeof contractsControllerCreateV1>>, TError = void>(
 createContractDto: CreateContractDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerCreateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsControllerCreateV1QueryOptions(createContractDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractsControllerSummaryV1Url = () => {




  return `/v1/contracts/summary`
}

/**
 * @summary The KPI tiles, counted in one transaction
 */
export const contractsControllerSummaryV1 = async ( options?: RequestInit): Promise<ContractSummaryDto> => {

  return apiRequest<ContractSummaryDto>(getContractsControllerSummaryV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getContractsControllerSummaryV1QueryKey = () => {
    return [
    `/v1/contracts/summary`
    ] as const;
    }


export const getContractsControllerSummaryV1QueryOptions = <TData = Awaited<ReturnType<typeof contractsControllerSummaryV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerSummaryV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsControllerSummaryV1QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsControllerSummaryV1>>> = ({ signal }) => contractsControllerSummaryV1({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsControllerSummaryV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsControllerSummaryV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractsControllerSummaryV1>>>
export type ContractsControllerSummaryV1QueryError = unknown


export function useContractsControllerSummaryV1<TData = Awaited<ReturnType<typeof contractsControllerSummaryV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerSummaryV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerSummaryV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerSummaryV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerSummaryV1<TData = Awaited<ReturnType<typeof contractsControllerSummaryV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerSummaryV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerSummaryV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerSummaryV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerSummaryV1<TData = Awaited<ReturnType<typeof contractsControllerSummaryV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerSummaryV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The KPI tiles, counted in one transaction
 */

export function useContractsControllerSummaryV1<TData = Awaited<ReturnType<typeof contractsControllerSummaryV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerSummaryV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsControllerSummaryV1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractsControllerRenewalsV1Url = (params?: ContractsControllerRenewalsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/contracts/renewals?${stringifiedParams}` : `/v1/contracts/renewals`
}

/**
 * Drafts and terminated contracts are excluded. Ordered by end date; `sortOrder` flips it. `bucket` narrows to one column of the deadline roadmap.
 * @summary Contracts ending within a year, bucketed
 */
export const contractsControllerRenewalsV1 = async (params?: ContractsControllerRenewalsV1Params, options?: RequestInit): Promise<ContractsControllerRenewalsV1200> => {

  return apiRequest<ContractsControllerRenewalsV1200>(getContractsControllerRenewalsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getContractsControllerRenewalsV1QueryKey = (params?: ContractsControllerRenewalsV1Params,) => {
    return [
    `/v1/contracts/renewals`, ...(params ? [params] : [])
    ] as const;
    }


export const getContractsControllerRenewalsV1QueryOptions = <TData = Awaited<ReturnType<typeof contractsControllerRenewalsV1>>, TError = unknown>(params?: ContractsControllerRenewalsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerRenewalsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsControllerRenewalsV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsControllerRenewalsV1>>> = ({ signal }) => contractsControllerRenewalsV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsControllerRenewalsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsControllerRenewalsV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractsControllerRenewalsV1>>>
export type ContractsControllerRenewalsV1QueryError = unknown


export function useContractsControllerRenewalsV1<TData = Awaited<ReturnType<typeof contractsControllerRenewalsV1>>, TError = unknown>(
 params: undefined |  ContractsControllerRenewalsV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerRenewalsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerRenewalsV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerRenewalsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerRenewalsV1<TData = Awaited<ReturnType<typeof contractsControllerRenewalsV1>>, TError = unknown>(
 params?: ContractsControllerRenewalsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerRenewalsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerRenewalsV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerRenewalsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerRenewalsV1<TData = Awaited<ReturnType<typeof contractsControllerRenewalsV1>>, TError = unknown>(
 params?: ContractsControllerRenewalsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerRenewalsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Contracts ending within a year, bucketed
 */

export function useContractsControllerRenewalsV1<TData = Awaited<ReturnType<typeof contractsControllerRenewalsV1>>, TError = unknown>(
 params?: ContractsControllerRenewalsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerRenewalsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsControllerRenewalsV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractsControllerFindOneV1Url = (id: string,) => {




  return `/v1/contracts/${id}`
}

/**
 * @summary One contract, with everything the page shows
 */
export const contractsControllerFindOneV1 = async (id: string, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractsControllerFindOneV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getContractsControllerFindOneV1QueryKey = (id: string,) => {
    return [
    `/v1/contracts/${id}`
    ] as const;
    }


export const getContractsControllerFindOneV1QueryOptions = <TData = Awaited<ReturnType<typeof contractsControllerFindOneV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerFindOneV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsControllerFindOneV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsControllerFindOneV1>>> = ({ signal }) => contractsControllerFindOneV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsControllerFindOneV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsControllerFindOneV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractsControllerFindOneV1>>>
export type ContractsControllerFindOneV1QueryError = unknown


export function useContractsControllerFindOneV1<TData = Awaited<ReturnType<typeof contractsControllerFindOneV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerFindOneV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerFindOneV1<TData = Awaited<ReturnType<typeof contractsControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerFindOneV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerFindOneV1<TData = Awaited<ReturnType<typeof contractsControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One contract, with everything the page shows
 */

export function useContractsControllerFindOneV1<TData = Awaited<ReturnType<typeof contractsControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsControllerFindOneV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractsControllerUpdateV1Url = (id: string,) => {




  return `/v1/contracts/${id}`
}

/**
 * Partial. `null` clears a clearable field. Every change to a tracked field writes a version with the field-level diff; a no-op update writes nothing.
 * @summary Amend the terms
 */
export const contractsControllerUpdateV1 = async (id: string,
    updateContractDto: UpdateContractDto, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractsControllerUpdateV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateContractDto)
  }
);}





export const getContractsControllerUpdateV1QueryKey = (id: string,
    updateContractDto?: UpdateContractDto,) => {
    return [
    'PATCH', `/v1/contracts/${id}`, updateContractDto
    ] as const;
    }


export const getContractsControllerUpdateV1QueryOptions = <TData = Awaited<ReturnType<typeof contractsControllerUpdateV1>>, TError = unknown>(id: string,
    updateContractDto: UpdateContractDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerUpdateV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsControllerUpdateV1QueryKey(id,updateContractDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsControllerUpdateV1>>> = ({ signal }) => contractsControllerUpdateV1(id,updateContractDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsControllerUpdateV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsControllerUpdateV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractsControllerUpdateV1>>>
export type ContractsControllerUpdateV1QueryError = unknown


export function useContractsControllerUpdateV1<TData = Awaited<ReturnType<typeof contractsControllerUpdateV1>>, TError = unknown>(
 id: string,
    updateContractDto: UpdateContractDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerUpdateV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerUpdateV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerUpdateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerUpdateV1<TData = Awaited<ReturnType<typeof contractsControllerUpdateV1>>, TError = unknown>(
 id: string,
    updateContractDto: UpdateContractDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerUpdateV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerUpdateV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerUpdateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerUpdateV1<TData = Awaited<ReturnType<typeof contractsControllerUpdateV1>>, TError = unknown>(
 id: string,
    updateContractDto: UpdateContractDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerUpdateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Amend the terms
 */

export function useContractsControllerUpdateV1<TData = Awaited<ReturnType<typeof contractsControllerUpdateV1>>, TError = unknown>(
 id: string,
    updateContractDto: UpdateContractDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerUpdateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsControllerUpdateV1QueryOptions(id,updateContractDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractsControllerRemoveV1Url = (id: string,) => {




  return `/v1/contracts/${id}`
}

/**
 * Anything that reached signature is history: terminate it instead.
 * @summary Delete a draft or in-review contract
 */
export const contractsControllerRemoveV1 = async (id: string, options?: RequestInit): Promise<RemoveContractResponseDto> => {

  return apiRequest<RemoveContractResponseDto>(getContractsControllerRemoveV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getContractsControllerRemoveV1QueryKey = (id: string,) => {
    return [
    'DELETE', `/v1/contracts/${id}`
    ] as const;
    }


export const getContractsControllerRemoveV1QueryOptions = <TData = Awaited<ReturnType<typeof contractsControllerRemoveV1>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerRemoveV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsControllerRemoveV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsControllerRemoveV1>>> = ({ signal }) => contractsControllerRemoveV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsControllerRemoveV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsControllerRemoveV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractsControllerRemoveV1>>>
export type ContractsControllerRemoveV1QueryError = void


export function useContractsControllerRemoveV1<TData = Awaited<ReturnType<typeof contractsControllerRemoveV1>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerRemoveV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerRemoveV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerRemoveV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerRemoveV1<TData = Awaited<ReturnType<typeof contractsControllerRemoveV1>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerRemoveV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerRemoveV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerRemoveV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerRemoveV1<TData = Awaited<ReturnType<typeof contractsControllerRemoveV1>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerRemoveV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete a draft or in-review contract
 */

export function useContractsControllerRemoveV1<TData = Awaited<ReturnType<typeof contractsControllerRemoveV1>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerRemoveV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsControllerRemoveV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractsControllerChangeStatusV1Url = (id: string,) => {




  return `/v1/contracts/${id}/status`
}

/**
 * Any of draft, in_review, out_for_signature, executed, expired, terminated, from any other. Executing completes an open signature round; any other move away from out_for_signature voids it. Executing requires a counterparty.
 * @summary Set the status
 */
export const contractsControllerChangeStatusV1 = async (id: string,
    changeContractStatusDto: ChangeContractStatusDto, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractsControllerChangeStatusV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changeContractStatusDto)
  }
);}





export const getContractsControllerChangeStatusV1QueryKey = (id: string,
    changeContractStatusDto?: ChangeContractStatusDto,) => {
    return [
    'POST', `/v1/contracts/${id}/status`, changeContractStatusDto
    ] as const;
    }


export const getContractsControllerChangeStatusV1QueryOptions = <TData = Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>, TError = void>(id: string,
    changeContractStatusDto: ChangeContractStatusDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsControllerChangeStatusV1QueryKey(id,changeContractStatusDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>> = ({ signal }) => contractsControllerChangeStatusV1(id,changeContractStatusDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsControllerChangeStatusV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>>
export type ContractsControllerChangeStatusV1QueryError = void


export function useContractsControllerChangeStatusV1<TData = Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>, TError = void>(
 id: string,
    changeContractStatusDto: ChangeContractStatusDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerChangeStatusV1<TData = Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>, TError = void>(
 id: string,
    changeContractStatusDto: ChangeContractStatusDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerChangeStatusV1<TData = Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>, TError = void>(
 id: string,
    changeContractStatusDto: ChangeContractStatusDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Set the status
 */

export function useContractsControllerChangeStatusV1<TData = Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>, TError = void>(
 id: string,
    changeContractStatusDto: ChangeContractStatusDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerChangeStatusV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsControllerChangeStatusV1QueryOptions(id,changeContractStatusDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractsControllerVersionsV1Url = (id: string,
    params?: ContractsControllerVersionsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/contracts/${id}/versions?${stringifiedParams}` : `/v1/contracts/${id}/versions`
}

/**
 * @summary The version history with field-level diffs
 */
export const contractsControllerVersionsV1 = async (id: string,
    params?: ContractsControllerVersionsV1Params, options?: RequestInit): Promise<ContractsControllerVersionsV1200> => {

  return apiRequest<ContractsControllerVersionsV1200>(getContractsControllerVersionsV1Url(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getContractsControllerVersionsV1QueryKey = (id: string,
    params?: ContractsControllerVersionsV1Params,) => {
    return [
    `/v1/contracts/${id}/versions`, ...(params ? [params] : [])
    ] as const;
    }


export const getContractsControllerVersionsV1QueryOptions = <TData = Awaited<ReturnType<typeof contractsControllerVersionsV1>>, TError = unknown>(id: string,
    params?: ContractsControllerVersionsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerVersionsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsControllerVersionsV1QueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsControllerVersionsV1>>> = ({ signal }) => contractsControllerVersionsV1(id,params, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsControllerVersionsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsControllerVersionsV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractsControllerVersionsV1>>>
export type ContractsControllerVersionsV1QueryError = unknown


export function useContractsControllerVersionsV1<TData = Awaited<ReturnType<typeof contractsControllerVersionsV1>>, TError = unknown>(
 id: string,
    params: undefined |  ContractsControllerVersionsV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerVersionsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerVersionsV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerVersionsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerVersionsV1<TData = Awaited<ReturnType<typeof contractsControllerVersionsV1>>, TError = unknown>(
 id: string,
    params?: ContractsControllerVersionsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerVersionsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsControllerVersionsV1>>,
          TError,
          Awaited<ReturnType<typeof contractsControllerVersionsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsControllerVersionsV1<TData = Awaited<ReturnType<typeof contractsControllerVersionsV1>>, TError = unknown>(
 id: string,
    params?: ContractsControllerVersionsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerVersionsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The version history with field-level diffs
 */

export function useContractsControllerVersionsV1<TData = Awaited<ReturnType<typeof contractsControllerVersionsV1>>, TError = unknown>(
 id: string,
    params?: ContractsControllerVersionsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsControllerVersionsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsControllerVersionsV1QueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractDocumentsControllerCreateV1Url = (id: string,) => {




  return `/v1/contracts/${id}/documents`
}

/**
 * @summary Attach a document (as its v1)
 */
export const contractDocumentsControllerCreateV1 = async (id: string,
    createContractDocumentDto: CreateContractDocumentDto, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractDocumentsControllerCreateV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createContractDocumentDto)
  }
);}





export const getContractDocumentsControllerCreateV1QueryKey = (id: string,
    createContractDocumentDto?: CreateContractDocumentDto,) => {
    return [
    'POST', `/v1/contracts/${id}/documents`, createContractDocumentDto
    ] as const;
    }


export const getContractDocumentsControllerCreateV1QueryOptions = <TData = Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>, TError = unknown>(id: string,
    createContractDocumentDto: CreateContractDocumentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractDocumentsControllerCreateV1QueryKey(id,createContractDocumentDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>> = ({ signal }) => contractDocumentsControllerCreateV1(id,createContractDocumentDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractDocumentsControllerCreateV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>>
export type ContractDocumentsControllerCreateV1QueryError = unknown


export function useContractDocumentsControllerCreateV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>, TError = unknown>(
 id: string,
    createContractDocumentDto: CreateContractDocumentDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>,
          TError,
          Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractDocumentsControllerCreateV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>, TError = unknown>(
 id: string,
    createContractDocumentDto: CreateContractDocumentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>,
          TError,
          Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractDocumentsControllerCreateV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>, TError = unknown>(
 id: string,
    createContractDocumentDto: CreateContractDocumentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Attach a document (as its v1)
 */

export function useContractDocumentsControllerCreateV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>, TError = unknown>(
 id: string,
    createContractDocumentDto: CreateContractDocumentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerCreateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractDocumentsControllerCreateV1QueryOptions(id,createContractDocumentDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractDocumentsControllerAddVersionV1Url = (id: string,
    documentId: string,) => {




  return `/v1/contracts/${id}/documents/${documentId}/versions`
}

/**
 * @summary Add a new version of a document
 */
export const contractDocumentsControllerAddVersionV1 = async (id: string,
    documentId: string,
    addContractDocumentVersionDto: AddContractDocumentVersionDto, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractDocumentsControllerAddVersionV1Url(id,documentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addContractDocumentVersionDto)
  }
);}





export const getContractDocumentsControllerAddVersionV1QueryKey = (id: string,
    documentId: string,
    addContractDocumentVersionDto?: AddContractDocumentVersionDto,) => {
    return [
    'POST', `/v1/contracts/${id}/documents/${documentId}/versions`, addContractDocumentVersionDto
    ] as const;
    }


export const getContractDocumentsControllerAddVersionV1QueryOptions = <TData = Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>, TError = unknown>(id: string,
    documentId: string,
    addContractDocumentVersionDto: AddContractDocumentVersionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractDocumentsControllerAddVersionV1QueryKey(id,documentId,addContractDocumentVersionDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>> = ({ signal }) => contractDocumentsControllerAddVersionV1(id,documentId,addContractDocumentVersionDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractDocumentsControllerAddVersionV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>>
export type ContractDocumentsControllerAddVersionV1QueryError = unknown


export function useContractDocumentsControllerAddVersionV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>, TError = unknown>(
 id: string,
    documentId: string,
    addContractDocumentVersionDto: AddContractDocumentVersionDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>,
          TError,
          Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractDocumentsControllerAddVersionV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>, TError = unknown>(
 id: string,
    documentId: string,
    addContractDocumentVersionDto: AddContractDocumentVersionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>,
          TError,
          Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractDocumentsControllerAddVersionV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>, TError = unknown>(
 id: string,
    documentId: string,
    addContractDocumentVersionDto: AddContractDocumentVersionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Add a new version of a document
 */

export function useContractDocumentsControllerAddVersionV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>, TError = unknown>(
 id: string,
    documentId: string,
    addContractDocumentVersionDto: AddContractDocumentVersionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerAddVersionV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractDocumentsControllerAddVersionV1QueryOptions(id,documentId,addContractDocumentVersionDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractDocumentsControllerRemoveV1Url = (id: string,
    documentId: string,) => {




  return `/v1/contracts/${id}/documents/${documentId}`
}

/**
 * @summary Remove a document and all its versions
 */
export const contractDocumentsControllerRemoveV1 = async (id: string,
    documentId: string, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractDocumentsControllerRemoveV1Url(id,documentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getContractDocumentsControllerRemoveV1QueryKey = (id: string,
    documentId: string,) => {
    return [
    'DELETE', `/v1/contracts/${id}/documents/${documentId}`
    ] as const;
    }


export const getContractDocumentsControllerRemoveV1QueryOptions = <TData = Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>, TError = unknown>(id: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractDocumentsControllerRemoveV1QueryKey(id,documentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>> = ({ signal }) => contractDocumentsControllerRemoveV1(id,documentId, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractDocumentsControllerRemoveV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>>
export type ContractDocumentsControllerRemoveV1QueryError = unknown


export function useContractDocumentsControllerRemoveV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>, TError = unknown>(
 id: string,
    documentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>,
          TError,
          Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractDocumentsControllerRemoveV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>, TError = unknown>(
 id: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>,
          TError,
          Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractDocumentsControllerRemoveV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>, TError = unknown>(
 id: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Remove a document and all its versions
 */

export function useContractDocumentsControllerRemoveV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>, TError = unknown>(
 id: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerRemoveV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractDocumentsControllerRemoveV1QueryOptions(id,documentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractDocumentsControllerDownloadV1Url = (id: string,
    documentId: string,
    params?: ContractDocumentsControllerDownloadV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/contracts/${id}/documents/${documentId}/download?${stringifiedParams}` : `/v1/contracts/${id}/documents/${documentId}/download`
}

/**
 * Defaults to the newest version. The download is audited.
 * @summary A short-lived signed URL
 */
export const contractDocumentsControllerDownloadV1 = async (id: string,
    documentId: string,
    params?: ContractDocumentsControllerDownloadV1Params, options?: RequestInit): Promise<DocumentDownloadDto> => {

  return apiRequest<DocumentDownloadDto>(getContractDocumentsControllerDownloadV1Url(id,documentId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getContractDocumentsControllerDownloadV1QueryKey = (id: string,
    documentId: string,
    params?: ContractDocumentsControllerDownloadV1Params,) => {
    return [
    `/v1/contracts/${id}/documents/${documentId}/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getContractDocumentsControllerDownloadV1QueryOptions = <TData = Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>, TError = unknown>(id: string,
    documentId: string,
    params?: ContractDocumentsControllerDownloadV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractDocumentsControllerDownloadV1QueryKey(id,documentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>> = ({ signal }) => contractDocumentsControllerDownloadV1(id,documentId,params, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractDocumentsControllerDownloadV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>>
export type ContractDocumentsControllerDownloadV1QueryError = unknown


export function useContractDocumentsControllerDownloadV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>, TError = unknown>(
 id: string,
    documentId: string,
    params: undefined |  ContractDocumentsControllerDownloadV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>,
          TError,
          Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractDocumentsControllerDownloadV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>, TError = unknown>(
 id: string,
    documentId: string,
    params?: ContractDocumentsControllerDownloadV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>,
          TError,
          Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractDocumentsControllerDownloadV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>, TError = unknown>(
 id: string,
    documentId: string,
    params?: ContractDocumentsControllerDownloadV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A short-lived signed URL
 */

export function useContractDocumentsControllerDownloadV1<TData = Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>, TError = unknown>(
 id: string,
    documentId: string,
    params?: ContractDocumentsControllerDownloadV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDocumentsControllerDownloadV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractDocumentsControllerDownloadV1QueryOptions(id,documentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractSignaturesControllerCreateV1Url = (id: string,) => {




  return `/v1/contracts/${id}/signature-requests`
}

/**
 * Moves the contract to out_for_signature. One open round at a time.
 * @summary Record that the contract went out for signature
 */
export const contractSignaturesControllerCreateV1 = async (id: string,
    createSignatureRequestDto: CreateSignatureRequestDto, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractSignaturesControllerCreateV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSignatureRequestDto)
  }
);}





export const getContractSignaturesControllerCreateV1QueryKey = (id: string,
    createSignatureRequestDto?: CreateSignatureRequestDto,) => {
    return [
    'POST', `/v1/contracts/${id}/signature-requests`, createSignatureRequestDto
    ] as const;
    }


export const getContractSignaturesControllerCreateV1QueryOptions = <TData = Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>, TError = void>(id: string,
    createSignatureRequestDto: CreateSignatureRequestDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractSignaturesControllerCreateV1QueryKey(id,createSignatureRequestDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>> = ({ signal }) => contractSignaturesControllerCreateV1(id,createSignatureRequestDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractSignaturesControllerCreateV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>>
export type ContractSignaturesControllerCreateV1QueryError = void


export function useContractSignaturesControllerCreateV1<TData = Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>, TError = void>(
 id: string,
    createSignatureRequestDto: CreateSignatureRequestDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>,
          TError,
          Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractSignaturesControllerCreateV1<TData = Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>, TError = void>(
 id: string,
    createSignatureRequestDto: CreateSignatureRequestDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>,
          TError,
          Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractSignaturesControllerCreateV1<TData = Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>, TError = void>(
 id: string,
    createSignatureRequestDto: CreateSignatureRequestDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Record that the contract went out for signature
 */

export function useContractSignaturesControllerCreateV1<TData = Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>, TError = void>(
 id: string,
    createSignatureRequestDto: CreateSignatureRequestDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerCreateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractSignaturesControllerCreateV1QueryOptions(id,createSignatureRequestDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractSignaturesControllerMarkSignedV1Url = (id: string,
    requestId: string,
    signerId: string,) => {




  return `/v1/contracts/${id}/signature-requests/${requestId}/signers/${signerId}/sign`
}

/**
 * An in-app record, not an electronic signature; the caller IP is kept as corroboration. The last signature completes the round and executes the contract.
 * @summary Record a signature
 */
export const contractSignaturesControllerMarkSignedV1 = async (id: string,
    requestId: string,
    signerId: string, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractSignaturesControllerMarkSignedV1Url(id,requestId,signerId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getContractSignaturesControllerMarkSignedV1QueryKey = (id: string,
    requestId: string,
    signerId: string,) => {
    return [
    'POST', `/v1/contracts/${id}/signature-requests/${requestId}/signers/${signerId}/sign`
    ] as const;
    }


export const getContractSignaturesControllerMarkSignedV1QueryOptions = <TData = Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>, TError = unknown>(id: string,
    requestId: string,
    signerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractSignaturesControllerMarkSignedV1QueryKey(id,requestId,signerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>> = ({ signal }) => contractSignaturesControllerMarkSignedV1(id,requestId,signerId, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && requestId !== null && requestId !== undefined && signerId !== null && signerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractSignaturesControllerMarkSignedV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>>
export type ContractSignaturesControllerMarkSignedV1QueryError = unknown


export function useContractSignaturesControllerMarkSignedV1<TData = Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>, TError = unknown>(
 id: string,
    requestId: string,
    signerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>,
          TError,
          Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractSignaturesControllerMarkSignedV1<TData = Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>, TError = unknown>(
 id: string,
    requestId: string,
    signerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>,
          TError,
          Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractSignaturesControllerMarkSignedV1<TData = Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>, TError = unknown>(
 id: string,
    requestId: string,
    signerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Record a signature
 */

export function useContractSignaturesControllerMarkSignedV1<TData = Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>, TError = unknown>(
 id: string,
    requestId: string,
    signerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerMarkSignedV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractSignaturesControllerMarkSignedV1QueryOptions(id,requestId,signerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractSignaturesControllerVoidV1Url = (id: string,
    requestId: string,) => {




  return `/v1/contracts/${id}/signature-requests/${requestId}/void`
}

/**
 * The contract returns to in_review; the round stays as history.
 * @summary Void the open round
 */
export const contractSignaturesControllerVoidV1 = async (id: string,
    requestId: string,
    voidSignatureRequestDto: VoidSignatureRequestDto, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractSignaturesControllerVoidV1Url(id,requestId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(voidSignatureRequestDto)
  }
);}





export const getContractSignaturesControllerVoidV1QueryKey = (id: string,
    requestId: string,
    voidSignatureRequestDto?: VoidSignatureRequestDto,) => {
    return [
    'POST', `/v1/contracts/${id}/signature-requests/${requestId}/void`, voidSignatureRequestDto
    ] as const;
    }


export const getContractSignaturesControllerVoidV1QueryOptions = <TData = Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>, TError = unknown>(id: string,
    requestId: string,
    voidSignatureRequestDto: VoidSignatureRequestDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractSignaturesControllerVoidV1QueryKey(id,requestId,voidSignatureRequestDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>> = ({ signal }) => contractSignaturesControllerVoidV1(id,requestId,voidSignatureRequestDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && requestId !== null && requestId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractSignaturesControllerVoidV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>>
export type ContractSignaturesControllerVoidV1QueryError = unknown


export function useContractSignaturesControllerVoidV1<TData = Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>, TError = unknown>(
 id: string,
    requestId: string,
    voidSignatureRequestDto: VoidSignatureRequestDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>,
          TError,
          Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractSignaturesControllerVoidV1<TData = Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>, TError = unknown>(
 id: string,
    requestId: string,
    voidSignatureRequestDto: VoidSignatureRequestDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>,
          TError,
          Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractSignaturesControllerVoidV1<TData = Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>, TError = unknown>(
 id: string,
    requestId: string,
    voidSignatureRequestDto: VoidSignatureRequestDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Void the open round
 */

export function useContractSignaturesControllerVoidV1<TData = Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>, TError = unknown>(
 id: string,
    requestId: string,
    voidSignatureRequestDto: VoidSignatureRequestDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractSignaturesControllerVoidV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractSignaturesControllerVoidV1QueryOptions(id,requestId,voidSignatureRequestDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getClauseLibraryControllerListV1Url = (params?: ClauseLibraryControllerListV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/clause-library?${stringifiedParams}` : `/v1/clause-library`
}

/**
 * @summary The agency's own clauses
 */
export const clauseLibraryControllerListV1 = async (params?: ClauseLibraryControllerListV1Params, options?: RequestInit): Promise<ClauseLibraryControllerListV1200> => {

  return apiRequest<ClauseLibraryControllerListV1200>(getClauseLibraryControllerListV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getClauseLibraryControllerListV1QueryKey = (params?: ClauseLibraryControllerListV1Params,) => {
    return [
    `/v1/clause-library`, ...(params ? [params] : [])
    ] as const;
    }


export const getClauseLibraryControllerListV1QueryOptions = <TData = Awaited<ReturnType<typeof clauseLibraryControllerListV1>>, TError = unknown>(params?: ClauseLibraryControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerListV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClauseLibraryControllerListV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clauseLibraryControllerListV1>>> = ({ signal }) => clauseLibraryControllerListV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerListV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClauseLibraryControllerListV1QueryResult = NonNullable<Awaited<ReturnType<typeof clauseLibraryControllerListV1>>>
export type ClauseLibraryControllerListV1QueryError = unknown


export function useClauseLibraryControllerListV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerListV1>>, TError = unknown>(
 params: undefined |  ClauseLibraryControllerListV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerListV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clauseLibraryControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof clauseLibraryControllerListV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClauseLibraryControllerListV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerListV1>>, TError = unknown>(
 params?: ClauseLibraryControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerListV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clauseLibraryControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof clauseLibraryControllerListV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClauseLibraryControllerListV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerListV1>>, TError = unknown>(
 params?: ClauseLibraryControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerListV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The agency's own clauses
 */

export function useClauseLibraryControllerListV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerListV1>>, TError = unknown>(
 params?: ClauseLibraryControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerListV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClauseLibraryControllerListV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getClauseLibraryControllerCreateV1Url = () => {




  return `/v1/clause-library`
}

/**
 * @summary Add a clause to the library
 */
export const clauseLibraryControllerCreateV1 = async (upsertLibraryClauseDto: UpsertLibraryClauseDto, options?: RequestInit): Promise<LibraryClauseDto> => {

  return apiRequest<LibraryClauseDto>(getClauseLibraryControllerCreateV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsertLibraryClauseDto)
  }
);}





export const getClauseLibraryControllerCreateV1QueryKey = (upsertLibraryClauseDto?: UpsertLibraryClauseDto,) => {
    return [
    'POST', `/v1/clause-library`, upsertLibraryClauseDto
    ] as const;
    }


export const getClauseLibraryControllerCreateV1QueryOptions = <TData = Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>, TError = unknown>(upsertLibraryClauseDto: UpsertLibraryClauseDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClauseLibraryControllerCreateV1QueryKey(upsertLibraryClauseDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>> = ({ signal }) => clauseLibraryControllerCreateV1(upsertLibraryClauseDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClauseLibraryControllerCreateV1QueryResult = NonNullable<Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>>
export type ClauseLibraryControllerCreateV1QueryError = unknown


export function useClauseLibraryControllerCreateV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>, TError = unknown>(
 upsertLibraryClauseDto: UpsertLibraryClauseDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>,
          TError,
          Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClauseLibraryControllerCreateV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>, TError = unknown>(
 upsertLibraryClauseDto: UpsertLibraryClauseDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>,
          TError,
          Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClauseLibraryControllerCreateV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>, TError = unknown>(
 upsertLibraryClauseDto: UpsertLibraryClauseDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Add a clause to the library
 */

export function useClauseLibraryControllerCreateV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>, TError = unknown>(
 upsertLibraryClauseDto: UpsertLibraryClauseDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerCreateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClauseLibraryControllerCreateV1QueryOptions(upsertLibraryClauseDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getClauseLibraryControllerSystemV1Url = () => {




  return `/v1/clause-library/system`
}

/**
 * A fixed set shared by every agency; not paginated by design.
 * @summary The standard clauses
 */
export const clauseLibraryControllerSystemV1 = async ( options?: RequestInit): Promise<SystemClausesResponseDto> => {

  return apiRequest<SystemClausesResponseDto>(getClauseLibraryControllerSystemV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getClauseLibraryControllerSystemV1QueryKey = () => {
    return [
    `/v1/clause-library/system`
    ] as const;
    }


export const getClauseLibraryControllerSystemV1QueryOptions = <TData = Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClauseLibraryControllerSystemV1QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>> = ({ signal }) => clauseLibraryControllerSystemV1({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClauseLibraryControllerSystemV1QueryResult = NonNullable<Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>>
export type ClauseLibraryControllerSystemV1QueryError = unknown


export function useClauseLibraryControllerSystemV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>,
          TError,
          Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClauseLibraryControllerSystemV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>,
          TError,
          Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClauseLibraryControllerSystemV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The standard clauses
 */

export function useClauseLibraryControllerSystemV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerSystemV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClauseLibraryControllerSystemV1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getClauseLibraryControllerUpdateV1Url = (clauseId: string,) => {




  return `/v1/clause-library/${clauseId}`
}

/**
 * Contracts that already copied it are untouched.
 * @summary Edit a library clause
 */
export const clauseLibraryControllerUpdateV1 = async (clauseId: string,
    upsertLibraryClauseDto: UpsertLibraryClauseDto, options?: RequestInit): Promise<LibraryClauseDto> => {

  return apiRequest<LibraryClauseDto>(getClauseLibraryControllerUpdateV1Url(clauseId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsertLibraryClauseDto)
  }
);}





export const getClauseLibraryControllerUpdateV1QueryKey = (clauseId: string,
    upsertLibraryClauseDto?: UpsertLibraryClauseDto,) => {
    return [
    'PATCH', `/v1/clause-library/${clauseId}`, upsertLibraryClauseDto
    ] as const;
    }


export const getClauseLibraryControllerUpdateV1QueryOptions = <TData = Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>, TError = unknown>(clauseId: string,
    upsertLibraryClauseDto: UpsertLibraryClauseDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClauseLibraryControllerUpdateV1QueryKey(clauseId,upsertLibraryClauseDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>> = ({ signal }) => clauseLibraryControllerUpdateV1(clauseId,upsertLibraryClauseDto, { signal });





   return  { queryKey, queryFn, enabled: clauseId !== null && clauseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClauseLibraryControllerUpdateV1QueryResult = NonNullable<Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>>
export type ClauseLibraryControllerUpdateV1QueryError = unknown


export function useClauseLibraryControllerUpdateV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>, TError = unknown>(
 clauseId: string,
    upsertLibraryClauseDto: UpsertLibraryClauseDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>,
          TError,
          Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClauseLibraryControllerUpdateV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>, TError = unknown>(
 clauseId: string,
    upsertLibraryClauseDto: UpsertLibraryClauseDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>,
          TError,
          Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClauseLibraryControllerUpdateV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>, TError = unknown>(
 clauseId: string,
    upsertLibraryClauseDto: UpsertLibraryClauseDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Edit a library clause
 */

export function useClauseLibraryControllerUpdateV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>, TError = unknown>(
 clauseId: string,
    upsertLibraryClauseDto: UpsertLibraryClauseDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerUpdateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClauseLibraryControllerUpdateV1QueryOptions(clauseId,upsertLibraryClauseDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getClauseLibraryControllerRemoveV1Url = (clauseId: string,) => {




  return `/v1/clause-library/${clauseId}`
}

/**
 * @summary Remove a library clause
 */
export const clauseLibraryControllerRemoveV1 = async (clauseId: string, options?: RequestInit): Promise<RemoveResponseDto> => {

  return apiRequest<RemoveResponseDto>(getClauseLibraryControllerRemoveV1Url(clauseId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClauseLibraryControllerRemoveV1QueryKey = (clauseId: string,) => {
    return [
    'DELETE', `/v1/clause-library/${clauseId}`
    ] as const;
    }


export const getClauseLibraryControllerRemoveV1QueryOptions = <TData = Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>, TError = unknown>(clauseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClauseLibraryControllerRemoveV1QueryKey(clauseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>> = ({ signal }) => clauseLibraryControllerRemoveV1(clauseId, { signal });





   return  { queryKey, queryFn, enabled: clauseId !== null && clauseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClauseLibraryControllerRemoveV1QueryResult = NonNullable<Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>>
export type ClauseLibraryControllerRemoveV1QueryError = unknown


export function useClauseLibraryControllerRemoveV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>, TError = unknown>(
 clauseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>,
          TError,
          Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClauseLibraryControllerRemoveV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>, TError = unknown>(
 clauseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>,
          TError,
          Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClauseLibraryControllerRemoveV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>, TError = unknown>(
 clauseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Remove a library clause
 */

export function useClauseLibraryControllerRemoveV1<TData = Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>, TError = unknown>(
 clauseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clauseLibraryControllerRemoveV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClauseLibraryControllerRemoveV1QueryOptions(clauseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractClausesControllerAttachV1Url = (id: string,) => {




  return `/v1/contracts/${id}/clauses`
}

/**
 * From the library, the system set, or written here. The text is copied onto the contract.
 * @summary Attach a clause
 */
export const contractClausesControllerAttachV1 = async (id: string,
    attachClauseDto: AttachClauseDto, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractClausesControllerAttachV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(attachClauseDto)
  }
);}





export const getContractClausesControllerAttachV1QueryKey = (id: string,
    attachClauseDto?: AttachClauseDto,) => {
    return [
    'POST', `/v1/contracts/${id}/clauses`, attachClauseDto
    ] as const;
    }


export const getContractClausesControllerAttachV1QueryOptions = <TData = Awaited<ReturnType<typeof contractClausesControllerAttachV1>>, TError = unknown>(id: string,
    attachClauseDto: AttachClauseDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractClausesControllerAttachV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractClausesControllerAttachV1QueryKey(id,attachClauseDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractClausesControllerAttachV1>>> = ({ signal }) => contractClausesControllerAttachV1(id,attachClauseDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractClausesControllerAttachV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractClausesControllerAttachV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractClausesControllerAttachV1>>>
export type ContractClausesControllerAttachV1QueryError = unknown


export function useContractClausesControllerAttachV1<TData = Awaited<ReturnType<typeof contractClausesControllerAttachV1>>, TError = unknown>(
 id: string,
    attachClauseDto: AttachClauseDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractClausesControllerAttachV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractClausesControllerAttachV1>>,
          TError,
          Awaited<ReturnType<typeof contractClausesControllerAttachV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractClausesControllerAttachV1<TData = Awaited<ReturnType<typeof contractClausesControllerAttachV1>>, TError = unknown>(
 id: string,
    attachClauseDto: AttachClauseDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractClausesControllerAttachV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractClausesControllerAttachV1>>,
          TError,
          Awaited<ReturnType<typeof contractClausesControllerAttachV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractClausesControllerAttachV1<TData = Awaited<ReturnType<typeof contractClausesControllerAttachV1>>, TError = unknown>(
 id: string,
    attachClauseDto: AttachClauseDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractClausesControllerAttachV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Attach a clause
 */

export function useContractClausesControllerAttachV1<TData = Awaited<ReturnType<typeof contractClausesControllerAttachV1>>, TError = unknown>(
 id: string,
    attachClauseDto: AttachClauseDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractClausesControllerAttachV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractClausesControllerAttachV1QueryOptions(id,attachClauseDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractClausesControllerDetachV1Url = (id: string,
    clauseId: string,) => {




  return `/v1/contracts/${id}/clauses/${clauseId}`
}

/**
 * @summary Remove a clause from the contract
 */
export const contractClausesControllerDetachV1 = async (id: string,
    clauseId: string, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractClausesControllerDetachV1Url(id,clauseId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getContractClausesControllerDetachV1QueryKey = (id: string,
    clauseId: string,) => {
    return [
    'DELETE', `/v1/contracts/${id}/clauses/${clauseId}`
    ] as const;
    }


export const getContractClausesControllerDetachV1QueryOptions = <TData = Awaited<ReturnType<typeof contractClausesControllerDetachV1>>, TError = unknown>(id: string,
    clauseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractClausesControllerDetachV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractClausesControllerDetachV1QueryKey(id,clauseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractClausesControllerDetachV1>>> = ({ signal }) => contractClausesControllerDetachV1(id,clauseId, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && clauseId !== null && clauseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractClausesControllerDetachV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractClausesControllerDetachV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractClausesControllerDetachV1>>>
export type ContractClausesControllerDetachV1QueryError = unknown


export function useContractClausesControllerDetachV1<TData = Awaited<ReturnType<typeof contractClausesControllerDetachV1>>, TError = unknown>(
 id: string,
    clauseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractClausesControllerDetachV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractClausesControllerDetachV1>>,
          TError,
          Awaited<ReturnType<typeof contractClausesControllerDetachV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractClausesControllerDetachV1<TData = Awaited<ReturnType<typeof contractClausesControllerDetachV1>>, TError = unknown>(
 id: string,
    clauseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractClausesControllerDetachV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractClausesControllerDetachV1>>,
          TError,
          Awaited<ReturnType<typeof contractClausesControllerDetachV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractClausesControllerDetachV1<TData = Awaited<ReturnType<typeof contractClausesControllerDetachV1>>, TError = unknown>(
 id: string,
    clauseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractClausesControllerDetachV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Remove a clause from the contract
 */

export function useContractClausesControllerDetachV1<TData = Awaited<ReturnType<typeof contractClausesControllerDetachV1>>, TError = unknown>(
 id: string,
    clauseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractClausesControllerDetachV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractClausesControllerDetachV1QueryOptions(id,clauseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractIncentivesControllerAddV1Url = (id: string,) => {




  return `/v1/contracts/${id}/incentives`
}

/**
 * @summary Add a bonus line
 */
export const contractIncentivesControllerAddV1 = async (id: string,
    incentiveInputDto: IncentiveInputDto, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractIncentivesControllerAddV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(incentiveInputDto)
  }
);}





export const getContractIncentivesControllerAddV1QueryKey = (id: string,
    incentiveInputDto?: IncentiveInputDto,) => {
    return [
    'POST', `/v1/contracts/${id}/incentives`, incentiveInputDto
    ] as const;
    }


export const getContractIncentivesControllerAddV1QueryOptions = <TData = Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>, TError = unknown>(id: string,
    incentiveInputDto: IncentiveInputDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractIncentivesControllerAddV1QueryKey(id,incentiveInputDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>> = ({ signal }) => contractIncentivesControllerAddV1(id,incentiveInputDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractIncentivesControllerAddV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>>
export type ContractIncentivesControllerAddV1QueryError = unknown


export function useContractIncentivesControllerAddV1<TData = Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>, TError = unknown>(
 id: string,
    incentiveInputDto: IncentiveInputDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>,
          TError,
          Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractIncentivesControllerAddV1<TData = Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>, TError = unknown>(
 id: string,
    incentiveInputDto: IncentiveInputDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>,
          TError,
          Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractIncentivesControllerAddV1<TData = Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>, TError = unknown>(
 id: string,
    incentiveInputDto: IncentiveInputDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Add a bonus line
 */

export function useContractIncentivesControllerAddV1<TData = Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>, TError = unknown>(
 id: string,
    incentiveInputDto: IncentiveInputDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerAddV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractIncentivesControllerAddV1QueryOptions(id,incentiveInputDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractIncentivesControllerUpdateV1Url = (id: string,
    incentiveId: string,) => {




  return `/v1/contracts/${id}/incentives/${incentiveId}`
}

/**
 * Partial; this is also how `achieved` is moved.
 * @summary Amend a bonus line
 */
export const contractIncentivesControllerUpdateV1 = async (id: string,
    incentiveId: string,
    updateIncentiveDto: UpdateIncentiveDto, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractIncentivesControllerUpdateV1Url(id,incentiveId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateIncentiveDto)
  }
);}





export const getContractIncentivesControllerUpdateV1QueryKey = (id: string,
    incentiveId: string,
    updateIncentiveDto?: UpdateIncentiveDto,) => {
    return [
    'PATCH', `/v1/contracts/${id}/incentives/${incentiveId}`, updateIncentiveDto
    ] as const;
    }


export const getContractIncentivesControllerUpdateV1QueryOptions = <TData = Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>, TError = unknown>(id: string,
    incentiveId: string,
    updateIncentiveDto: UpdateIncentiveDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractIncentivesControllerUpdateV1QueryKey(id,incentiveId,updateIncentiveDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>> = ({ signal }) => contractIncentivesControllerUpdateV1(id,incentiveId,updateIncentiveDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && incentiveId !== null && incentiveId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractIncentivesControllerUpdateV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>>
export type ContractIncentivesControllerUpdateV1QueryError = unknown


export function useContractIncentivesControllerUpdateV1<TData = Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>, TError = unknown>(
 id: string,
    incentiveId: string,
    updateIncentiveDto: UpdateIncentiveDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>,
          TError,
          Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractIncentivesControllerUpdateV1<TData = Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>, TError = unknown>(
 id: string,
    incentiveId: string,
    updateIncentiveDto: UpdateIncentiveDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>,
          TError,
          Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractIncentivesControllerUpdateV1<TData = Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>, TError = unknown>(
 id: string,
    incentiveId: string,
    updateIncentiveDto: UpdateIncentiveDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Amend a bonus line
 */

export function useContractIncentivesControllerUpdateV1<TData = Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>, TError = unknown>(
 id: string,
    incentiveId: string,
    updateIncentiveDto: UpdateIncentiveDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerUpdateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractIncentivesControllerUpdateV1QueryOptions(id,incentiveId,updateIncentiveDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getContractIncentivesControllerRemoveV1Url = (id: string,
    incentiveId: string,) => {




  return `/v1/contracts/${id}/incentives/${incentiveId}`
}

/**
 * @summary Remove a bonus line
 */
export const contractIncentivesControllerRemoveV1 = async (id: string,
    incentiveId: string, options?: RequestInit): Promise<ContractDto> => {

  return apiRequest<ContractDto>(getContractIncentivesControllerRemoveV1Url(id,incentiveId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getContractIncentivesControllerRemoveV1QueryKey = (id: string,
    incentiveId: string,) => {
    return [
    'DELETE', `/v1/contracts/${id}/incentives/${incentiveId}`
    ] as const;
    }


export const getContractIncentivesControllerRemoveV1QueryOptions = <TData = Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>, TError = unknown>(id: string,
    incentiveId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractIncentivesControllerRemoveV1QueryKey(id,incentiveId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>> = ({ signal }) => contractIncentivesControllerRemoveV1(id,incentiveId, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && incentiveId !== null && incentiveId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractIncentivesControllerRemoveV1QueryResult = NonNullable<Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>>
export type ContractIncentivesControllerRemoveV1QueryError = unknown


export function useContractIncentivesControllerRemoveV1<TData = Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>, TError = unknown>(
 id: string,
    incentiveId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>,
          TError,
          Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractIncentivesControllerRemoveV1<TData = Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>, TError = unknown>(
 id: string,
    incentiveId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>,
          TError,
          Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractIncentivesControllerRemoveV1<TData = Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>, TError = unknown>(
 id: string,
    incentiveId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Remove a bonus line
 */

export function useContractIncentivesControllerRemoveV1<TData = Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>, TError = unknown>(
 id: string,
    incentiveId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractIncentivesControllerRemoveV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractIncentivesControllerRemoveV1QueryOptions(id,incentiveId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






